module.exports = {
    currency: {
        style: 'currency',
        currency: 'USD'
     }
}
